<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"><h5 class="mb-0">Bloques TEP</h5></div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">TEP</li>
                  <li class="breadcrumb-item active">General</li>
                  <li class="breadcrumb-item active">Bloques</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="card-header pt-2 pb-2">
                <div class="btn-group float-right">
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-if="$store.getters.can('tep.bloques.create')"
                    data-toggle="modal"
                    data-target="#modal-tep-bloque"
                    @click="abrirModalCrear()"
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>

              <div class="card-body">
                <div class="row">
                  <div class="form-group col-md-3">
                    <label>Bloque</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="filtros.bloque"
                    />
                  </div>
                  <div class="form-group col-md-2">
                    <label>Prefijo</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="filtros.prefijo"
                    />
                  </div>
                  <div class="form-group col-md-2">
                    <label>Código</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="filtros.codigo"
                    />
                  </div>
                  <div class="form-group col-md-3">
                    <label>Estado</label>
                    <select
                      class="form-control form-control-sm"
                      v-model="filtros.estado"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="estado in listasForms.estados"
                        :key="estado.numeracion"
                        :value="estado.numeracion"
                      >
                        {{ estado.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group col-md-2 pt-4 text-right">
                    <div class="btn-group">
                      <button class="btn bg-navy btn-sm" @click="getIndex()">
                        <i class="fas fa-search"></i>
                      </button>
                      <button class="btn btn-danger btn-sm" @click="limpiar()">
                        <i class="fas fa-broom"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card-body table-responsive p-0">
                <table
                  class="table table-bordered table-striped table-hover table-sm"
                >
                  <thead class="bg-dark">
                    <tr>
                      <th>Bloque</th>
                      <th>Prefijo</th>
                      <th>Código</th>
                      <th>Dirección</th>
                      <th>Estado</th>
                      <th>Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="bloque in bloques.data" :key="bloque.id">
                      <td>{{ bloque.nombre }}</td>
                      <td>{{ bloque.prefijo }}</td>
                      <td>{{ bloque.codigo }}</td>
                      <td>{{ bloque.direccion }}</td>
                      <td>
                        <span
                          class="badge"
                          :class="
                            bloque.estado == 1
                              ? 'badge-success'
                              : 'badge-danger'
                          "
                        >
                          {{ bloque.nEstado }}
                        </span>
                      </td>
                      <td>
                        <div class="btn-group">
                          <button
                            type="button"
                            class="btn btn-sm bg-navy"
                            v-if="$store.getters.can('tep.bloques.show')"
                            data-toggle="modal"
                            data-target="#modal-tep-bloque"
                            @click="abrirModalEditar(bloque)"
                          >
                            <i class="fas fa-edit"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-sm btn-danger"
                            v-if="$store.getters.can('tep.bloques.delete')"
                            @click="destroy(bloque.id)"
                          >
                            <i class="fas fa-trash-alt"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="card-footer">
                <div class="float-left" v-if="bloques.total">
                  Mostrando del <b>{{ bloques.from }}</b> al
                  <b>{{ bloques.to }}</b> de
                  <b>{{ bloques.total }}</b> registros
                </div>
                <div class="float-left" v-else>
                  <span class="badge badge-danger"
                    >No hay registros para mostrar</span
                  >
                </div>
                <pagination
                  :data="bloques"
                  @pagination-change-page="getIndex"
                  :limit="3"
                  class="float-right m-0"
                ></pagination>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <div
      class="modal fade"
      id="modal-tep-bloque"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h5 class="modal-title text-white">
              {{ gestion.id ? "Editar bloque" : "Crear bloque" }}
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body p-0 pt-1">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="tab-datos"
                  data-toggle="tab"
                  href="#datos"
                  >Datos</a
                >
              </li>
              <li class="nav-item" v-if="gestion.id">
                <a
                  class="nav-link"
                  id="tab-geocerca"
                  data-toggle="tab"
                  href="#geocerca"
                  >Geocerca</a
                >
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade active show" id="datos">
                <div class="card-body">
                  <div class="row">
                    <div class="form-group col-md-4">
                      <label>Nombre</label>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="gestion.nombre"
                        :class="
                          $v.gestion.nombre.$invalid ? 'is-invalid' : 'is-valid'
                        "
                      />
                    </div>
                    <div class="form-group col-md-2">
                      <label>Prefijo</label>
                      <input
                        type="text"
                        maxlength="3"
                        class="form-control form-control-sm"
                        v-model="gestion.prefijo"
                        :class="
                          $v.gestion.prefijo.$invalid
                            ? 'is-invalid'
                            : 'is-valid'
                        "
                      />
                    </div>
                    <div class="form-group col-md-2">
                      <label>Código</label>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="gestion.codigo"
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label>Pais</label>
                      <v-select
                        class="form-control form-control-sm p-0"
                        v-model="gestion.pais_id"
                        label="nombre"
                        :options="listasForms.paises"
                        :reduce="(p) => p.id"
                        @input="filtrarDepartamentosGestion"
                        :class="[
                          $v.gestion.pais_id.$invalid
                            ? 'is-invalid'
                            : 'is-valid',
                          $store.getters.getDarkMode ? 'dark-vselect' : '',
                        ]"
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label>Departamento</label>
                      <v-select
                        class="form-control form-control-sm p-0"
                        :class="[
                          $v.gestion.departamento_id.$invalid
                            ? 'is-invalid'
                            : 'is-valid',
                          $store.getters.getDarkMode ? 'dark-vselect' : '',
                        ]"
                        v-model="gestion.departamento_id"
                        label="descripcion"
                        :options="listasForms.departamentosGestion"
                        :reduce="(d) => d.id"
                        @input="filtrarCiudadesGestion"
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label>Ciudad</label>
                      <v-select
                        class="form-control form-control-sm p-0"
                        :class="[
                          $v.gestion.ciudad_id.$invalid
                            ? 'is-invalid'
                            : 'is-valid',
                          $store.getters.getDarkMode ? 'dark-vselect' : '',
                        ]"
                        v-model="gestion.ciudad_id"
                        label="nombre"
                        :options="listasForms.ciudadesGestion"
                        :reduce="(c) => c.id"
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label>Dirección</label>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="gestion.direccion"
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label>Operación Modelo (Año)</label>
                      <input
                        type="number"
                        min="1"
                        class="form-control form-control-sm"
                        v-model="gestion.modelo_vehiculo"
                        :class="
                          $v.gestion.modelo_vehiculo.$invalid
                            ? 'is-invalid'
                            : 'is-valid'
                        "
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label>Estado</label>
                      <select
                        class="form-control form-control-sm"
                        v-model="gestion.estado"
                        :class="[
                          $v.gestion.estado.$invalid
                            ? 'is-invalid'
                            : 'is-valid',
                        ]"
                      >
                        <option value="">Seleccione...</option>
                        <option
                          v-for="estado in listasForms.estados"
                          :key="estado.numeracion"
                          :value="estado.numeracion"
                        >
                          {{ estado.descripcion }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="geocerca" v-if="gestion.id">
                <TepBloqueGeocerca
                  :entity="gestion"
                  :estados="listasForms.estados"
                  @loading="cargando = $event"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary btn-sm" @click="guardarBloque()">
              <i class="fas fa-save"></i> Guardar
            </button>
            <button class="btn btn-secondary btn-sm" data-dismiss="modal">
              <i class="fas fa-times"></i> Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import pagination from "laravel-vue-pagination";
import { required, minValue, maxValue } from "vuelidate/lib/validators";
import Loading from "../../../../components/Loading";
import TepBloqueGeocerca from "./TepBloqueGeocerca.vue";
export default {
  name: "TepBloqueIndex",
  components: { Loading, pagination, vSelect, TepBloqueGeocerca },
  data() {
    return {
      cargando: false,
      tabModal: "datos",
      bloques: {},
      listasIniciales: { departamentos: [], ciudades: [] },
      maxYear: new Date().getFullYear() + 1,
      gestion: {
        id: null,
        nombre: null,
        prefijo: null,
        codigo: null,
        pais_id: null,
        departamento_id: null,
        ciudad_id: null,
        direccion: null,
        modelo_vehiculo: null,
        estado: 1,
      },
      filtros: {
        bloque: null,
        prefijo: null,
        codigo: null,
        estado: null,
      },
      listasForms: {
        estados: [],
        paises: [],
        departamentosGestion: [],
        ciudadesGestion: [],
      },
    };
  },
  validations() {
    return {
      gestion: {
        nombre: {
          required,
        },
        prefijo: {
          required,
        },
        pais_id: {
          required,
        },
        departamento_id: {
          required,
        },
        ciudad_id: {
          required,
        },
        direccion: {
          required,
        },
        modelo_vehiculo: {
          required,
          minValue: minValue(1),
          maxValue: maxValue(50),
        },
        estado: {
          required,
        },
      },
    };
  },
  methods: {
    getIndex(page = 1) {
      this.cargando = true;
      axios
        .get("/api/tep/bloques?page=" + page, { params: this.filtros })
        .then((response) => {
          this.bloques = response.data;
          this.cargando = false;
        })
        .catch(() => {
          this.cargando = false;
        });
    },
    getEstados() {
      axios.get("/api/lista/1").then((response) => {
        this.listasForms.estados = response.data;
      });
    },
    getPaises() {
      axios.get("/api/admin/paises/lista").then((response) => {
        this.listasForms.paises = response.data;
      });
    },
    getDepartamentos() {
      axios.get("/api/admin/departamentos/lista").then((response) => {
        this.listasIniciales.departamentos = response.data;
      });
    },
    getCiudades() {
      axios.get("/api/admin/ciudades/lista").then((response) => {
        this.listasIniciales.ciudades = response.data;
      });
    },
    filtrarDepartamentosGestion() {
      this.listasForms.departamentosGestion = [];
      this.gestion.departamento_id = null;
      this.listasForms.ciudadesGestion = [];
      this.gestion.ciudad_id = null;
      if (this.gestion.pais_id) {
        this.listasForms.departamentosGestion =
          this.listasIniciales.departamentos.filter(
            (d) => d.pais_id === this.gestion.pais_id
          );
      }
    },
    filtrarCiudadesGestion() {
      this.listasForms.ciudadesGestion = [];
      this.gestion.ciudad_id = null;
      if (this.gestion.departamento_id) {
        this.listasForms.ciudadesGestion = this.listasIniciales.ciudades.filter(
          (c) => c.departamento_id === this.gestion.departamento_id
        );
      }
    },
    abrirModalCrear() {
      this.resetGestion();
      this.tabModal = "datos";
    },
    abrirModalEditar(bloque) {
      this.tabModal = "datos";
      this.cargando = true;
      axios
        .get("/api/tep/bloques/show/" + bloque.id)
        .then((response) => {
          const data = response.data;
          this.gestion = {
            id: data.id,
            nombre: data.nombre,
            prefijo: data.prefijo,
            codigo: data.codigo,
            pais_id: data.pais_id,
            departamento_id: data.departamento_id,
            ciudad_id: data.ciudad_id,
            direccion: data.direccion,
            modelo_vehiculo: data.modelo_vehiculo,
            estado: data.estado,
            geocerca: data.geocerca || null,
          };
          this.listasForms.departamentosGestion =
            this.listasIniciales.departamentos.filter(
              (d) => d.pais_id === this.gestion.pais_id
            );
          this.listasForms.ciudadesGestion =
            this.listasIniciales.ciudades.filter(
              (c) => c.departamento_id === this.gestion.departamento_id
            );
          this.cargando = false;
        })
        .catch(() => {
          this.cargando = false;
        });
    },
    guardarBloque() {
      if (!this.gestion.nombre) {
        this.$swal({
          icon: "warning",
          title: "El nombre del bloque es obligatorio",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }
      this.cargando = true;
      axios({
        method: this.gestion.id ? "PUT" : "POST",
        url: "/api/tep/bloques",
        data: this.gestion,
      })
        .then((response) => {
          const guardado = response.data || {};
          this.gestion.id = guardado.id || this.gestion.id;
          this.gestion.geocerca =
            guardado.geocerca || this.gestion.geocerca || null;
          this.getIndex();
          this.cargando = false;
          this.$swal({
            icon: "success",
            title: "Bloque guardado exitosamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch(() => {
          this.cargando = false;
        });
    },
    resetGestion() {
      this.gestion = {
        id: null,
        nombre: null,
        prefijo: null,
        codigo: null,
        pais_id: null,
        departamento_id: null,
        ciudad_id: null,
        direccion: null,
        estado: 1,
        geocerca: null,
      };
      this.listasForms.departamentosGestion = [];
      this.listasForms.ciudadesGestion = [];
    },
    limpiar() {
      this.filtros = {
        bloque: null,
        prefijo: null,
        codigo: null,
        estado: null,
      };
      this.getIndex();
    },
    destroy(id) {
      this.$swal({
        title: "Esta seguro de eliminar el bloque?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        if (result.value) {
          this.cargando = true;
          axios.delete("/api/tep/bloques/" + id).then(() => {
            this.getIndex();
            this.cargando = false;
          });
        }
      });
    },
  },
  mounted() {
    this.getEstados();
    this.getPaises();
    this.getDepartamentos();
    this.getCiudades();
    this.getIndex();
  },
};
</script>
